import { FormControl, TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ChangeEventHandler, MouseEventHandler } from 'react';

export const PasswordField: React.FC<{
  showPassword: boolean;
  password: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onClickVisibilityIcon?: MouseEventHandler<HTMLButtonElement>;
}> = ({ showPassword, password, onChange, onClickVisibilityIcon }) => {
  return (
    <FormControl className="provision-field">
      <TextField
        id="database-password"
        label="Database Password"
        type={showPassword ? 'text' : 'password'}
        value={password}
        name="password"
        onChange={onChange}
        autoComplete="new-password"
        fullWidth
        variant="outlined"
        placeholder="Enter database password"
        helperText="Password for database authentication"
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
          },
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={onClickVisibilityIcon}
                  edge="end"
                  aria-label="toggle password visibility"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </FormControl>
  );
};
